/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLoyaltyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-loyalty"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M22.02 14.68L14.7 22Q14.3 22.4 13.81 22.59Q13.32 22.77 12.82 22.77Q12.32 22.77 11.84 22.59Q11.35 22.4 10.95 22L1.98 13.07Q1.6 12.7 1.4 12.21Q1.2 11.72 1.2 11.2L1.2 3.85Q1.2 2.73 1.96 1.96Q2.73 1.2 3.85 1.2L11.15 1.2Q11.68 1.2 12.16 1.4Q12.65 1.6 13.03 1.98L22.02 10.93Q22.43 11.32 22.61 11.81Q22.8 12.3 22.8 12.8Q22.8 13.3 22.61 13.79Q22.43 14.28 22.02 14.68ZM6.67 8.5Q7.42 8.5 7.96 7.96Q8.5 7.42 8.5 6.67Q8.5 5.92 7.96 5.39Q7.42 4.85 6.67 4.85Q5.92 4.85 5.39 5.39Q4.85 5.92 4.85 6.67Q4.85 7.42 5.39 7.96Q5.92 8.5 6.67 8.5ZM13.97 17.07L16.9 14.22Q17.25 13.88 17.43 13.45Q17.6 13.03 17.6 12.53Q17.6 11.55 16.9 10.86Q16.2 10.18 15.2 10.18Q14.72 10.18 14.24 10.43Q13.75 10.68 13.05 11.3Q12.22 10.65 11.76 10.41Q11.3 10.18 10.85 10.18Q9.85 10.18 9.15 10.86Q8.45 11.55 8.45 12.53Q8.45 13.03 8.63 13.45Q8.8 13.88 9.15 14.22L12.13 17.07Q12.53 17.45 13.06 17.45Q13.6 17.45 13.97 17.07Z" fill={color} />
    </svg>
  );
}
